import { useTranslation } from 'react-i18next'

import { ArrowUDownLeftIcon } from '@phosphor-icons/react'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'
import InfoTooltip from '@/metrics/components/InfoTooltip/InfoTooltip'
import ReasonsBreakdownTable from '@/metrics/components/ReasonsBreakdownTable/ReasonsBreakdownTable'

import { subReasonsDescriptions } from './constants'
import * as Styles from './styles'

const SubReasonsCard = ({ subReasons, loading, showExchanges, orderBy, onClickSubReason }) => {
  const { t } = useTranslation()

  const isSubReasonClickable = subReason => subReason.id !== null

  const description = showExchanges ? subReasonsDescriptions.withExchanges : subReasonsDescriptions.withoutExchanges

  return (
    <Card showBorder={false}>
      <CardTitle>
        <Styles.Title>
          <ArrowUDownLeftIcon size={24} />
          {t('Submotivos')}
        </Styles.Title>
        <InfoTooltip
          text={t('Se cuentan unidades de producto devueltas, según la fecha en que se completó la devolución.')}
        />
      </CardTitle>
      <CardDescription>{t(description)}</CardDescription>
      <ReasonsBreakdownTable
        nameLabel={t('Submotivo')}
        reasons={subReasons}
        loading={loading}
        showExchanges={showExchanges}
        orderBy={orderBy}
        onClickReason={onClickSubReason}
        isRowClickable={isSubReasonClickable}
      />
    </Card>
  )
}

export default SubReasonsCard
